/* eslint-disable @typescript-eslint/no-explicit-any */
export const total = (property: any): number => {
  let price = 0.0;
  property.fees.map((fee: { price: string; }) => {
    price = price + parseFloat(fee.price);
  });

  return (parseFloat((parseFloat(property.price) + price).toFixed(2)));
};

export const readImage = (image: any) => {
  const binaryData: any = new Uint8Array(image)
  const blob = new Blob([binaryData], { type: "image/jpeg" })
  const imageUrl = URL.createObjectURL(blob)
  return imageUrl;
}

export const selectPrice = (price : any, prices : any, guests : any, commission = 20) => {
  let tax = price / 100 * commission
  let result = price + tax;
  prices.map((price : any) => {
    if(price.guests <= guests){
      tax = price.price / 100 * commission
      result = price.price + tax;
    }
  })
  return result;
}
